<template>
  <sweet-modal
    ref="modal"
    @class="vld - parent"
    @open="setDuplicateTemplate(true)"
    @close="closeModal"
    hide-close-button
  >
    <loading :active="savingTemplate" :is-full-page="false"></loading>
    <p>
      {{ $t('modals.duplicate_description') }}<br />
      {{ this.duplicateName }}
    </p>
    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" @click="duplicate">
        {{ $t('modals.duplicate_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';

export default {
  name: 'DuplicateTemplateModal',
  components: {
    SweetModal,
    Loading
  },
  computed: {
    ...mapState({
      savingTemplate: state => state.savingTemplate,
      success: state => state.success,
      selectedTemplate: state => state.duplicateTemplateData
    }),
    duplicateName: function () {
      return this.selectedTemplate
        ? 'copy-of-' + this.selectedTemplate.name
        : '-';
    }
  },
  methods: {
    ...mapMutations([
      'setSuccess',
      'setDuplicateTemplate',
      'setDuplicateTemplateData'
    ]),
    ...mapActions(['duplicateTemplate']),
    duplicate: function () {
      this.setSuccess(false);
      this.duplicateTemplate({
        originalTemplate: this.selectedTemplate.id,
        overwrite: false
      });
    },
    open: function (template) {
      this.setDuplicateTemplateData(template);
      this.$refs.modal.open();
    },
    closeModal: function () {
      this.setDuplicateTemplateData({});
      this.setDuplicateTemplate(false);
    },
    close: function () {
      this.$refs.modal.close();
    }
  },
  watch: {
    success: function (newValue) {
      if (newValue !== undefined && newValue === true) {
        this.$refs.modal.close();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
